// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { BRANCH_OFFICES_ENDPOINT } from '../../../../../../../utility/SourceAPI'

export const getBranchOffices = createAsyncThunk('appBranchOffices/getBranchOffices', async () => {
    const response = await axios.get(BRANCH_OFFICES_ENDPOINT)
    return {
        data: response.data
    }
})

export const addBranchOffice = createAsyncThunk('appBranchOffices/addBranchOffice', async (branchOffice, { dispatch }) => {
    const response = await axios.post(BRANCH_OFFICES_ENDPOINT, branchOffice)
    // eslint-disable-next-line no-use-before-define
    dispatch(getBranchOffices())
    return response.data
})

export const appBranchOfficesSlice = createSlice({
    name: 'appBranchOffices',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getBranchOffices.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default appBranchOfficesSlice.reducer